import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
// import { AngularFireModule } from "@angular/fire/compat";
import { Facebook } from '@ionic-native/facebook/ngx';

import { FormsModule } from '@angular/forms';
import {
  BrowserModule,
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { BoxxImagesModule } from '@boxx/boxx-images';
import { ContactsCoreModule } from '@boxx/contacts-core';
import { APP_VERSION_SERVICE, CoreModule, NATIVE_STORAGE_SERVICE } from '@boxx/core';
import { DynamicBrandingCoreModule } from '@boxx/dynamic-branding/lib/dynamic-branding.module';
import { EventsCoreModule } from '@boxx/events-core';
import { GmbCoreModule } from '@boxx/gmb-core';
import { LoginCoreModule, LoginService } from '@boxx/login-core';
import { MessagesCoreModule } from '@boxx/messages-core';
import { BoxxOAuthModule } from '@boxx/OAuth';
import { OnboardingCoreModule, OnboardingService } from '@boxx/onboarding-core';
import { PanelCoreModule } from '@boxx/panel-core';
import { ProfileCoreModule } from '@boxx/profile-core';
import { SharedComponentsModule } from '@boxx/shared-components';
import { StoreCoreModule, StoreRepositoryMock, STORE_REPOSITORY } from '@boxx/store-core';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { APP_CONSTANTS } from 'src/constants/constants';
import { environment } from 'src/environments/environment';
import { AppVersionService } from 'src/services/NativeAppVersion.service';
import { NativeFirebaseModule } from 'src/services/NativeFirebase/NativeFirebase.module';
import { LocalNotificationsService } from 'src/services/NativeLocalNotification.service';
//import { LocalNotificationsService } from 'src/services/NativeLocalNotification.service';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { SharingService } from 'src/services/NativeSharing.service';
import { NotificationsService } from 'src/services/Nofitications.service';
//import { SharingService } from 'src/services/NativeSharing.service';
import { MultilingualModule } from 'src/services/translate/translate.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './helpers/error-interceptor';
import { BoxxJwtInterceptor } from './helpers/jwt-interceptor';
import { BottomSheetModule } from './components/bottom-sheet/bottom-sheet.module';
//import { PaymentLinkCoreModule } from '@boxx/payment-core/payment-core.module';
import { SocialSharing } from '@ionic-native/social-sharing/ngx'; // Importa el plugin aquí
import { UpsertSheetModule } from './components/upsert-sheet/upsert-sheet.module';
import { DateTimeSheetModule } from './components/datetime-sheet/datetime-sheet.module';
import { BusinessFacade } from './pages/home/state/facades/business.facade';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      backButtonText: '',
      backButtonIcon: 'arrow-back-circle-outline',
      menuIcon: './assets/icon/Btn_HeaderView2ndMenu.svg',
      mode: "md",
    }),
    FormsModule,
    HttpClientModule,

    //AngularFireModule.initializeApp(APP_CONSTANTS.firebaseConfigForGMB),
    //AngularFireMessagingModule,

    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),

    NativeFirebaseModule,

    CoreModule.forRoot({
      appConstants: APP_CONSTANTS,
      environment,
      providers: [{ provide: NATIVE_STORAGE_SERVICE, useClass: LocalStorageNativeService }],
    }),

    ContactsCoreModule.forRoot(),

    DynamicBrandingCoreModule.forRoot({
      providers: [{ provide: NATIVE_STORAGE_SERVICE, useClass: LocalStorageNativeService }],
    }),

    EventsCoreModule.forRoot(),

    GmbCoreModule.forRoot(),

    BoxxImagesModule,
    BoxxOAuthModule,

    LoginCoreModule.forRoot({
      providers: [
        {
          provide: NATIVE_STORAGE_SERVICE,
          useClass: LocalStorageNativeService,
        },
      ],
    }),

    MessagesCoreModule.forRoot({
      providers: [
        //{ provide: MESSAGES_REPOSITORY, useClass: MockMessagesRepository },
      ],
    }),

    OnboardingCoreModule.forRoot({
      providers: [
        //{ provide: ONBOARDING_REPOSITORY, useClass: OnboardingRepositoryMock },
      ],
    }),

    ProfileCoreModule.forRoot(),

    PanelCoreModule.forRoot(),

    StoreCoreModule.forRoot(),
    // StoreCoreModule.forRoot({
    //   providers: [{ provide: STORE_REPOSITORY, useClass: StoreRepositoryMock }],
    // }),

    //PaymentLinkCoreModule.forRoot(),

    SharedComponentsModule.forRoot({
      providers: [
        { provide: APP_VERSION_SERVICE, useClass: AppVersionService },
      ],
    }),

    StoreDevtoolsModule.instrument({
      name: 'My Boxx App',
      logOnly: !environment.production,
      maxAge: 25,
    }),

    MultilingualModule,
    // ServiceWorkerModule.register('combined-sw.js', {
    //   enabled: environment.production,
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    BottomSheetModule,
    DateTimeSheetModule, 
    UpsertSheetModule,
    AppRoutingModule,
    StoreModule.forRoot({}, {}),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
  ],
  providers: [
    Facebook,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: BoxxJwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig, deps: [] },
    LocalStorageNativeService,
    BusinessFacade,
    //LocalNotifications,
    LocalNotificationsService,
    //TouchID,
    SharingService,
    NotificationsService,
    LoginService,
    OnboardingService,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}
}
